import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export const getCurrentNakshatraData = async (
  profileId: string,
  selectedNakshatra: string,
  date: string,
  language: string
) => {
  const url = `${urls.currentNakshatra}/${profileId}/${selectedNakshatra}/${date}/${language}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
